import React from "react";
import leftTree from "../../assets/images/left-tree.png";
import righttree from "../../assets/images/right-tree.png";
import { useState, useEffect } from "react";
import axios from "axios";
import { apiurl } from "../../Constants";
import { addToCart } from "../../features/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { fetchComboOfferData } from "../../features/comboOfferSlice";
function Combooffer() {
  // const [comboofferData, setComboofferdata] = useState([]);

  const [loading, setLoading] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { items: cartitems } = useSelector((state) => state.cartitems);

  const IsinCart = (product_id) => {
    return (
      cartitems && cartitems.some((cartdata) => cartdata.id === product_id)
    );
  };

  const user_id = localStorage.getItem("userId");

  const { comboOfferData, error, status } = useSelector(
    (state) => state.combooffer
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchComboOfferData());
    }
  }, [dispatch, status]);

  const CustomPrevArrow = ({ onClick }) => {
    return (
      <button className="custom-prev-arrow" onClick={onClick}>
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    );
  };

  const CustomNextArrow = ({ onClick }) => {
    return (
      <button className="custom-next-arrow" onClick={onClick}>
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    );
  };

  const [sliderSettings, setSlidersettings] = useState({
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    margin: 8,
    nav: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 767, // Below 767px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991, // Below 991px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024, // You can add more breakpoints if needed
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  const handleAddToCart = (item) => {
    if (!user_id) {
      navigate("/login");
      return;
    }
    setLoading(true);
    dispatch(addToCart({ user_id, product_id: item, quantity: 1 }))
      .then(() => {
        setAddedToCart(true);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {comboOfferData && comboOfferData.length > 0 ? (
        <section className="combooffer_section  pb-40">
          <div className="container">
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-xl-6 col-lg-6 main-heading-inner-box">
                <div className="inner-box">
                  <img
                    src={leftTree}
                    alt="img"
                    className="heading-left-image"
                  />
                  <h3 className="main-heading-1">Special Combo offer</h3>
                  <img
                    src={righttree}
                    alt="img"
                    className="heading-right-image"
                  />
                </div>
              </div>
            </div>

            <div className="row second_row">
              <Slider {...sliderSettings}>
                {comboOfferData.map((item, index) => {
                  return (
                    <>
                      <div className="grid_col" key={index}>
                        <div
                          className="main_box"
                          style={{
                            backgroundImage: `url(${item?.combo_img})`,
                          }}
                        >
                          <div className="row">
                            <div className="col-lg-7 col-md-7 left_col"></div>
                            <div className="col-lg-5 col-md-5 col-sm-12 right_col">
                              <div className="inner_box">
                                <h5>{item?.product_name}</h5>
                                <h4>
                                  RM &nbsp;
                                  {item.discount_price == 0 ? (
                                    <>{item?.actual_price}</>
                                  ) : (
                                    <>{item?.discount_price}</>
                                  )}
                                </h4>
                                <div className="text-center">
                                  {IsinCart(item?.id) ? (
                                    <button
                                      onClick={() => navigate("/cart")}
                                      className="btn_1 go_to_cart_btn"
                                    >
                                      Go to Cart
                                    </button>
                                  ) : (
                                    <button
                                      className="btn_1"
                                      onClick={() => handleAddToCart(item?.id)}
                                    >
                                      {loading ? (
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                      ) : (
                                        "Add to Cart"
                                      )}
                                    </button>
                                  )}
                                  {/* <button
                           className="btn_1"
                           onClick={() => handleAddToCart(item.id)}
                         >
                           {loading ? (
                           <span
                             className="spinner-border spinner-border-sm"
                             role="status"
                             aria-hidden="true"
                           ></span>
                         ) : (
                           "Add to Cart"
                         )}
                         </button> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}{" "}
              </Slider>
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}

export default Combooffer;
